import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { IModifyTimeDashboardItem } from 'src/app/dashboards/common/items/modify-time';
import { IDataLoaderResult } from 'src/app/services/data-loader/data-loader-result';
import {
    IDashboardItem,
    IDashboardItemFactory,
} from 'src/app/utils/dashboard-item';

export interface IDataTextDashboardItem extends IDashboardItem {
    /** Text to display */
    dataText: string;
    /** Type of text to display */
    type: 'plain' | 'warning';
    /** Show loading text when data is being loaded */
    showOnLoading?: boolean;
}

@Component({
    selector: 'app-data-text',
    templateUrl: './data-text.component.html',
    styleUrls: ['./data-text.component.scss'],
})
export class DataTextComponent implements OnInit {
    @Input()
    dashboardItemFactory!: IDashboardItemFactory;
    dashboardItem!: IModifyTimeDashboardItem;

    @Input()
    dataLoaderEmitter!: EventEmitter<IDataLoaderResult>;

    dataText: string = 'Loading...';

    private dataLoaderSubscriber = (dataLoaderResult: IDataLoaderResult) => {
        console.log({
            msg: `[DataTextComponent][${this.dashboardItem.instanceId}] Got dataLoaderResult`,
            dataLoaderResult,
        });

        if (dataLoaderResult.isLoading) {
            this.dataText = 'Loading...';
        } else {
            if (dataLoaderResult.status == 'error') {
                this.dataText = 'Error';
            } else {
            }
        }

        if (dataLoaderResult.status == 'ok') {
            const data = this.dashboardItem.composeData(
                dataLoaderResult.data,
                dataLoaderResult.queryContext
            );
            this.dataText = data;
        }
    };

    ngOnInit(): void {
        this.dashboardItem = this.dashboardItemFactory.create();
        this.dataLoaderEmitter.subscribe(this.dataLoaderSubscriber);
    }
}
